import { render, staticRenderFns } from "./TenantBookingsLink.vue?vue&type=template&id=61ca77a3&scoped=true&"
import script from "./TenantBookingsLink.vue?vue&type=script&lang=js&"
export * from "./TenantBookingsLink.vue?vue&type=script&lang=js&"
import style0 from "./TenantBookingsLink.vue?vue&type=style&index=0&id=61ca77a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ca77a3",
  null
  
)

export default component.exports